import { useForm } from '@inertiajs/inertia-react';
import usePageProps from 'app/components/hooks/usePageProps';
import Layout from 'app/components/Layouts/Layout'
import { UserType } from 'app/components/Types/UserType';
import ColumnGraph from 'app/fragments/ColumnGraph';
import { ChangeImage } from 'app/fragments/Forms/ChangeImage';
import Form from 'app/fragments/Forms/Form'
import PasswordField from 'app/fragments/Forms/PasswordField';
import Submit from 'app/fragments/Forms/Submit';
import TextField from 'app/fragments/Forms/TextField';
import React from 'react'
import route from 'ziggy-js';

interface Props {
    user_detail: UserType
 }

function Detail(props: Props) {
    const { user_detail: user } = props

    // const { user_detail } = usePageProps<{ user: UserType }>();

    const form = useForm({
        name: user.name,
        UUID: user.UUID,
        email: user.email,
    });
    const { data, post } = form;

    const submit = (e) => {
        e.preventDefault();
        post(route('user.update', {user: user.UUID}));
    }

    return (
        <Layout heading='Team' withoutPadding>
                        <div className="flex justify-between mt-40px px-30px">
                <h2 className="text-24 font-bold">Data for {user.name}</h2>
                <div>
                    <div></div>
                    {/* <a className="cursor-pointer" onClick={() => open(MODALS.NEWTASK)}><IconText className="bg-green-539648 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Task" /></a> */}
                </div>
            </div>
            {/* <div className=" mt-16px px-30px text-16 text-[#CCCCCC]">
                look at all these stats, <span className='font-bold'>aren't they beautiful?</span>.
            </div> */}
            <ColumnGraph user={user} />
        </Layout>
    )
}

export default Detail
